import { createFileRoute } from '@tanstack/react-router';

import { LoginPanel, type LoginError } from '../features/auth/login-panel';

/**
 * `/login` — 로그인 (E14 §2)
 *
 * 라우트는 얇게 둔다: search param 스키마와 조립만 하고 화면은 `features/auth`에 있다.
 *
 * 모달이 아니라 라우트인 이유는 온보딩과 같다 (S0 §3 문제 5) — 로그인이 필요해 막힌 요청은
 * 돌아갈 곳을 주소로 가리켜야 한다(`return_path`). 모달에는 주소가 없다.
 */
const LOGIN_ERRORS = new Set<LoginError>(['cancelled', 'failed', 'too_many', 'unavailable']);

/** 둘 다 선택 항목이다 — `/login`으로 갈 때 search param을 요구하지 않는다 */
interface LoginSearch {
  error?: LoginError;
  return_path?: string;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    // 서버가 붙여 보내는 사유 코드. 모르는 값은 무시한다 (E14 §4 가산 전용 규칙의 클라이언트 쪽)
    error: LOGIN_ERRORS.has(search.error as LoginError) ? (search.error as LoginError) : undefined,
    return_path:
      typeof search.return_path === 'string' && search.return_path.startsWith('/')
        ? search.return_path
        : undefined,
  }),
  component: LoginScreen,
});

function LoginScreen() {
  const { error, return_path } = Route.useSearch();

  return <LoginPanel error={error} returnPath={return_path} />;
}
